import React, { useEffect } from "react";

import { Route, Switch, Redirect } from "react-router-dom";
// import { Helmet } from "react-helmet";

import SEO from "./components/SEO";

import {
  Container,
  useBreakpointValue,
  // VisuallyHidden,
} from "@chakra-ui/react";

import { Header } from "./components/Header";

import { Home, Font, Color, NotFound } from "./pages";

import { Breakpoints } from "./context";

import { useGaTracker } from "./hooks";

import "./customScroll.css";

function App() {
  let device = useBreakpointValue({
    base: "mobile",
    md: "tab",
    lg: "desktop",
  });

  var WebFont = require("webfontloader");

  useGaTracker();

  useEffect(() => {
    let fontVal = localStorage.getItem("FontFamilies");
    let myArr = [];
    if (fontVal) {
      let myFonts = JSON.parse(fontVal);

      for (let i = 0; i < myFonts.length; i++) {
        myArr.push(myFonts[i].cardValue);
      }
    }

    if (myArr.length === 0) {
      WebFont.load({
        google: {
          families: ["Nunito", "Roboto"],
        },
      });
    } else {
      WebFont.load({
        google: {
          families: [...myArr],
        },
      });
    }
  });

  return (
    <Breakpoints.Provider value={device}>
      <div className="App" style={{ background: "#f8f8f8" }}>
        <Header />

        {/* SEO */}
        <SEO
          title="Felco ThemeGen"
          desc="Create Design Systems and Style guide for your Brand or Personal Projects and
          export them as js, json."
          keywords="ThemeGen, Themeit, themify, Design System, create Design Systems, Style guide, design system software, Theme Generator, Generate Themes,theme.js, type-scale, type scale, type scale generator, font scale, golden ratio, color, color-palette, color palette generator, palette generator"
          url="https://themegen.netlify.app/"
          type="website"
          img="https://felcoimg.netlify.app/img/home.png"
        >
          <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6991856412998100"
        crossorigin="anonymous"></script>
        </SEO>

        {/* <Helmet>
          <title>Felco ThemeGen</title>
          <meta name="title" content="Felco ThemeGen" />
          <meta
            name="description"
            content="Generate Themes And Export, Theme Generator"
          />
          <meta
            name="keywords"
            content="ThemeGen, Themeit, themify, Theme Generator, Generate Themes, theme.js, type-scale, type scale, type scale generator, font scale, golden ratio, color, color-palette, color palette generator, palette generator"
          />
          <link rel="canonical" href="https://themegen.netlify.app/" />

          {/* Open Graph / Facebook  
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://themegen.netlify.app/" />
          <meta property="og:title" content="Felco ThemeGen" />
          <meta
            property="og:description"
            content="Generate Themes And Export, Theme Generator"
          />
          {/* <meta property="og:image" content='' /> 

          {/* Twitter  
          <meta property="twitter:card" content="summary_large_image" />
          <meta
            property="twitter:url"
            content="https://themegen.netlify.app/"
          />
          <meta property="twitter:title" content="Felco ThemeGen" />
          <meta
            property="twitter:description"
            content="Generate Themes And Export, Theme Generator"
          />
          {/* <meta property="twitter:image" content="" /> 
        </Helmet> */}

        {/* <VisuallyHidden>
          Felco Themegen is a Design System Creator and Style Guide. That helps
          developers and designers to create visual typography style guide and
          color theme palette for their Brands Design and Personal Projects and
          export them as js, json.
        </VisuallyHidden> */}

        <Container
          p="0"
          minW={{ base: "305px", md: "628px", lg: "1226px" }}
          maxW={{ base: "305px", md: "628px", lg: "1226px" }}
        >
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/font" component={Font} />
            <Route path="/color-palette" component={Color} />
            <Route path="/404" component={NotFound} />
            {/* <Route path="*" component={NotFound} /> */}
            <Redirect to="/404" />
          </Switch>
        </Container>
      </div>
    </Breakpoints.Provider>
  );
}

export default App;
